/**
 * Constants for survey item types and their display properties
 */

export const ITEM_TYPES = {
  INFORMATIONAL: 'informational',
  INTRODUCTION: 'introduction',
  QUESTION: 'question',
  OPEN_ENDED: 'open-ended',
  RATING: 'rating',
  MULTIPLE_CHOICE: 'multiple-choice',
};

export const ITEM_TYPE_LABELS = {
  [ITEM_TYPES.INFORMATIONAL]: 'Informational',
  [ITEM_TYPES.INTRODUCTION]: 'Introduction',
  [ITEM_TYPES.QUESTION]: 'Question',
  [ITEM_TYPES.OPEN_ENDED]: 'Open-Ended',
  [ITEM_TYPES.RATING]: 'Rating',
  [ITEM_TYPES.MULTIPLE_CHOICE]: 'Multiple Choice',
};

export const getItemTypeIcon = (type) => {
  return type; // Icons will be determined in the component using lucide-react
};